import { Component, Input, OnInit } from '@angular/core';
import { Outcome, OutcomeRequestApi, OutcomeService } from 'src/app/services/outcome.service';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {

  @Input('reqdata') reqdata: OutcomeRequestApi[]  = null; 
  @Input('ocdata') ocdata: Outcome = null;

  reqStart = this.calendar.getToday();
  reqEnd = null;
  requestSelected: OutcomeRequestApi = null;
  requestNew: OutcomeRequestApi = null;
  selectedIndex: number = -1;
  notes: string = '';
  requestCFS: number = 0;

  outcomeEvent: any = null;

  private unsubscribe: Subject<any> = new Subject();

  private saved: boolean = false;

  constructor(
    private calendar: NgbCalendar,
    private outcomeService: OutcomeService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit() {
    this.outcomeService.currentOCRequestEvent$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(event => {
      this.outcomeEvent = event;
      if (!!event && !!(event.target) && event.target.innerText === 'Ok') {
        if (!this.saved && (!!this.requestNew || !!this.requestSelected)) {
          this.updateRequest();
          console.log('request update 1');
        }
      }
    });
  }

  overlap(request: OutcomeRequestApi): boolean {
    if (!this.reqdata) {
      return false;
    }
    var reStartDate = new Date(`${this.reqStart.year}/${this.reqStart.month}/${this.reqStart.day}`);
    var earlydate = new Date(`1900/1/1`);
    for (var i =0; i< this.reqdata.length; i++) {
      var de = new Date(this.reqdata[i].endDate);
      if (de < earlydate) {
        var ds = new Date(this.reqdata[i].startDate);
        if (reStartDate >= ds) {
          if (request.outcomeRequestId == this.reqdata[i].outcomeRequestId) {
            return false;
          } else {
            return true;
          }
        }
      }
    }
    return false;
  }

  updateRequest() {
    this.saved = true;
    if (!!this.requestNew) {
      if (this.overlap(this.requestNew)) {
        this.toastrService.warning('Create Request', 
        'Can not create request, need to terminate open-ended request first.', {
          positionClass: 'toast-top-right',
          closeButton: true,
          disableTimeOut: false,
          timeOut: 5000,
          extendedTimeOut: 5000,
        });
        this.requestNew = null;
        this.requestSelected = null;
        return;
      }
      this.requestNew.requestCFS = this.requestCFS;
      this.requestNew.notes = this.notes;
      this.requestNew.startDate = new Date(`${this.reqStart.year}/${this.reqStart.month}/${this.reqStart.day}`);
      if (!!this.reqEnd) {
        this.requestNew.endDate = new Date(`${this.reqEnd.year}/${this.reqEnd.month}/${this.reqEnd.day}`);
      } else {
        this.requestNew.endDate = new Date(`1/1/1`);
      }
      //call service to send back to server
      this.outcomeService.putRequest(this.requestNew);
      this.outcomeService.getReports(this.requestNew.year);
    } else if (!!this.requestSelected) {
      if (this.overlap(this.requestSelected)) {
        this.toastrService.warning('', 
        'Can not update request, need to terminate open-ended request first.', {
          positionClass: 'toast-top-right',
          closeButton: true,
          disableTimeOut: false,
          timeOut: 5000,
          extendedTimeOut: 5000,
        });
        this.requestNew = null;
        this.requestSelected = null;
        return;
      }

      this.requestSelected.requestCFS = this.requestCFS;
      this.requestSelected.notes = this.notes;
      this.requestSelected.startDate = new Date(`${this.reqStart.year}/${this.reqStart.month}/${this.reqStart.day}`);
      if (!!this.reqEnd) {
        this.requestSelected.endDate = new Date(`${this.reqEnd.year}/${this.reqEnd.month}/${this.reqEnd.day}`);
      } else {
        this.requestSelected.endDate = new Date(`1/1/1`);
      }
      //call service to send update to server
      this.outcomeService.putRequest(this.requestSelected);
      this.outcomeService.getReports(this.requestSelected.year);
    }

    this.requestNew = null;
    this.requestSelected = null;
  }

  updateRequestSelection($event) {
    if ($event >= 0) {
      this.requestSelected = this.reqdata[$event];
      this.requestCFS = this.requestSelected.requestCFS;
      this.notes = this.requestSelected.notes;
      var request_year_start = new Date(`${this.requestSelected.year}/1/1`);
      var d = this.requestSelected.startDate;
      var rdate_s = new Date(d);
      this.reqStart = new NgbDate(rdate_s.getFullYear(), rdate_s.getMonth()+1, rdate_s.getDate());
      d = this.requestSelected.endDate;
      var rdate_e = new Date(d);
      if (rdate_e < request_year_start || rdate_e < rdate_s ) {
        this.reqEnd = null;
      } else {
        this.reqEnd = new NgbDate(rdate_e.getFullYear(), rdate_e.getMonth()+1, rdate_e.getDate());
      }
      this.requestNew = null;
    } else if ($event === -999) {
      //create a new request
      var y = this.ocdata.dates[0].getFullYear();
      this.requestNew = {
        outcomeRequestId : 0,
        permitAnnualOperatingPlanId : this.ocdata.permitAnnualOperatingPlanId,
        requestCFS : 0,
        startDate : new Date(`${y}/4/1`),
        endDate : null,
        notes : '',
        applicationNumber : '', //actually it doesn't matter which application number it is
        waterRightsId : '', //actually it doesn't matter which water right Id it is
        actual : 0,
        grant : 0,
        appropriatorId : this.ocdata.appropriatorId,
        appropriatorName : this.ocdata.appropriatorName, 
        permitPointOfDiversionId : this.ocdata.permitPointOfDiversionId,
        permitPointOfDiversionName : this.ocdata.permitPointOfDiversionName,
        year : y,
      }
      this.reqStart = new NgbDate(y, 4, 1); 
      this.reqEnd = null;
      this.requestSelected = null;
      this.notes = '';
      this.requestCFS = 0;
    }
  }

  endDateDisplay(req: OutcomeRequestApi) {
    var s = new Date(`${req.year}/1/1`);
    var d = new Date(req.endDate);
    if (d < s) {
      return 'No end date';
    } else {
      return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
    }
  }
  
}
